// extracted by mini-css-extract-plugin
export default {"header":"RequestStatusHeader_header__NbtYJ","status":"RequestStatusHeader_status__n3-PL"};